// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__vVq4Y","brand":"Footer_brand__-i+kk","heading":"Footer_heading__HBpJe","author":"Footer_author__hXUMi","link":"Footer_link__ocx6Y"};